module.exports = __webpack_public_path__ + "media/images/flags/lt-4c19d3a9f8cb00a45baa5b619cc1dc21.svg";